"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorageManager = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var StorageManager = function () {
  function StorageManager(iframeCompatible, primaryStorage, usePrimaryOnly) {
    if (iframeCompatible === void 0) {
      iframeCompatible = false;
    }
    if (primaryStorage === void 0) {
      primaryStorage = 'cookie';
    }
    if (usePrimaryOnly === void 0) {
      usePrimaryOnly = false;
    }
    var _this = this;
    this.storageContainers = ['cookie', 'local', 'session'];
    this.set = function (key, value, expires, domain) {
      var options = _this.cookieOptions(key, value, expires, domain);
      var setFuncs = {
        cookie: _this.setCookie.bind(null, key, value, options),
        session: _this.setSessionStorage.bind(null, key, value),
        local: _this.setLocalStorage.bind(null, key, value, expires)
      };
      for (var _i = 0, _a = _this.storageContainers; _i < _a.length; _i++) {
        var storage = _a[_i];
        setFuncs[storage]();
        if (_this.usePrimaryOnly) break;
      }
    };
    this.get = function (key) {
      var getFuncs = {
        cookie: _this.getCookie.bind(null, key),
        session: _this.getSessionStorage.bind(null, key),
        local: _this.getLocalStorage.bind(null, key)
      };
      var value = null;
      for (var _i = 0, _a = _this.storageContainers; _i < _a.length; _i++) {
        var storage = _a[_i];
        value = getFuncs[storage]();
        if (value) {
          return value;
        }
      }
    };
    this.unset = function (key, domain) {
      var options = domain ? _this.cookieOptions(key, null, null, domain) : null;
      var unsetFuncs = {
        cookie: js_cookie_1.default.remove.bind(null, key, options),
        session: function () {
          return sessionStorage && sessionStorage.removeItem(key);
        },
        local: function () {
          return localStorage && localStorage.removeItem(key);
        }
      };
      for (var _i = 0, _a = _this.storageContainers; _i < _a.length; _i++) {
        var storage = _a[_i];
        unsetFuncs[storage]();
      }
    };
    this.unsetByPrefixes = function (prefixes) {
      var keysToDelete = new Set();
      var existingCookies = document.cookie.split(';');
      existingCookies.forEach(function (cookie) {
        var name = cookie.split('=').map(function (c) {
          return c.trim();
        })[0];
        if (prefixes.some(function (prefix) {
          return name.startsWith(prefix);
        })) {
          keysToDelete.add(name);
        }
      });
      var _loop_1 = function (i) {
        var key = localStorage.key(i);
        if (key && prefixes.some(function (prefix) {
          return key.startsWith(prefix);
        })) {
          keysToDelete.add(key);
        }
      };
      for (var i = 0; i < localStorage.length; i++) {
        _loop_1(i);
      }
      var _loop_2 = function (i) {
        var key = sessionStorage.key(i);
        if (key && prefixes.some(function (prefix) {
          return key.startsWith(prefix);
        })) {
          keysToDelete.add(key);
        }
      };
      for (var i = 0; i < sessionStorage.length; i++) {
        _loop_2(i);
      }
      if (keysToDelete.size > 0) {
        keysToDelete.forEach(function (key) {
          _this.unset(key);
        });
        return Array.from(keysToDelete).join(', ');
      }
    };
    this.setCookie = function (key, value, options) {
      js_cookie_1.default.set(key, value, options);
    };
    this.setLocalStorage = function (key, value, expires) {
      if (window.localStorage && expires) {
        var item = {
          value: value,
          expiry: expires.getTime()
        };
        window.localStorage.setItem(key, JSON.stringify(item));
      }
    };
    this.setSessionStorage = function (key, value) {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(key, value);
      }
    };
    this.getCookie = function (key) {
      return js_cookie_1.default.get(key);
    };
    this.getSessionStorage = function (key) {
      return window.sessionStorage ? window.sessionStorage.getItem(key) : '';
    };
    this.getLocalStorage = function (key) {
      if (window.localStorage) {
        var itemStr = window.localStorage.getItem(key);
        try {
          var item = JSON.parse(itemStr);
          var now = new Date();
          if (item.expiry && now.getTime() > item.expiry) {
            window.localStorage.removeItem(key);
            return;
          }
          return item.value;
        } catch (_a) {
          if (itemStr) return itemStr;
        }
      }
    };
    this.iframeCompatible = iframeCompatible;
    this.primaryStorage = primaryStorage;
    this.usePrimaryOnly = usePrimaryOnly;
    if (primaryStorage !== 'cookie') {
      var primaryStorageIndex = this.storageContainers.indexOf(primaryStorage);
      this.storageContainers.unshift(this.storageContainers.splice(primaryStorageIndex, 1)[0]);
    }
    if (usePrimaryOnly) {
      if (primaryStorage === 'session' && !window.sessionStorage || primaryStorage === 'local' && !window.localStorage) {
        this.usePrimaryOnly = false;
      }
    }
  }
  StorageManager.prototype.cookieOptions = function (key, value, expires, domain) {
    var expiresOption = expires ? {
      expires: expires
    } : {};
    var domainOption = domain ? domain : document.location.hostname;
    var options = __assign({
      domain: domainOption,
      path: '/'
    }, expiresOption);
    if (this.iframeCompatible) {
      if (window.parent && window.location !== window.parent.location) {
        options.sameSite = 'none';
      }
      options.secure = true;
    }
    return options;
  };
  return StorageManager;
}();
exports.StorageManager = StorageManager;
exports.default = StorageManager;